export enum AccountsRoutePathsEnum {
  ACCOUNTS = '/accounts',
}
